// eslint-disable-next-line max-classes-per-file
import { AxiosResponse } from 'axios';

import { instance as axios } from 'api/axios';
import { Reservations, GetReservPar, ReservCell, ReservationsRelevanceCheckResult } from './interfaces';

class MyError extends Error {
  errorExtraParamsGet;

  constructor(message: any, errorExtraParams: any) {
    super(message);
    this.errorExtraParamsGet = errorExtraParams;
  }

  get errorExtraParams() {
    return this.errorExtraParamsGet;
  }
}

export class ReservationsService {
  static prefix = '/Reservation';

  public static async getReservations(params: GetReservPar) {
    const url = `${ReservationsService.prefix}`;

    try {
      const response: AxiosResponse<Reservations[]> = await axios.get(url, { params });
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.UserMessage || 'Виникла помилка');
    }
  }

  public static async checkIfNeedsRefreshment(params: GetReservPar) {
    const url = `${ReservationsService.prefix}/NeedsRefreshment`;

    try {
      const response: AxiosResponse<ReservationsRelevanceCheckResult> = await axios.get(url, { params });
      return response.data.shouldBeRefreshed;
    } catch (error: any) {
      throw new Error(error.response?.data?.UserMessage || 'Виникла помилка');
    }
  }

  // cell creating
  public static async postReservationsCell(body: any) {
    try {
      const url = `/Cell/Lock`;

      const response: AxiosResponse<ReservCell> = await axios.post(url, body);

      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.UserMessage || 'Виникла помилка');
    }
  }

  // создаётся бук для ячейки
  public static async postReservations(body: any) {
    try {
      const url = `${ReservationsService.prefix}`;

      const response: AxiosResponse<any> = await axios.post(url, body);
      return response.data;
    } catch (error: any) {
      throw new MyError(error, error.response);
    }
  }

  // обновляется бук для ячейки
  public static async editReservations(params: any) {
    try {
      const url = `${ReservationsService.prefix}`;

      const response: AxiosResponse<any> = await axios.put(url, params);
      return response.data;
    } catch (error: any) {
      throw new MyError(error, error.response);
    }
  }

  public static async putСellBlock(body: FormData) {
    try {
      const url = `${ReservationsService.prefix}/Cell/Block`;

      const response: AxiosResponse<any> = await axios.put(url, body);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.UserMessage || 'Виникла помилка');
    }
  }

  public static async putСellBlockByDate(data: FormData) {
    try {
      const url = `${ReservationsService.prefix}/Cell/Block/ByData`;

      const response: AxiosResponse<any> = await axios.put(url, data);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.UserMessage || 'Виникла помилка');
    }
  }

  public static async putСellBlockDay(data: FormData) {
    try {
      const url = `${ReservationsService.prefix}/Cell/Block/Day`;

      const response: AxiosResponse<any> = await axios.put(url, data);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.UserMessage || 'Виникла помилка');
    }
  }

  public static async putReservations(params: any) {
    try {
      const url = `${ReservationsService.prefix}/Status`;

      const response: AxiosResponse<any> = await axios.put(url, params);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.UserMessage || 'Виникла помилка');
    }
  }

  public static async getCellSettings(branchId: number) {
    try {
      const url = `/Cell/Setting`;

      const response: any = await axios.get(url, { params: { branchId } });
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.UserMessage || 'Виникла помилка');
    }
  }

  public static async getLockedCell(params: GetReservPar) {
    try {
      const url = `/Cell/Locked`;
      const response: any = await axios.get(url, { params });
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.UserMessage || 'Виникла помилка');
    }
  }

  public static async getSettings(branchId: number) {
    try {
      const url = `${ReservationsService.prefix}/Settings`;

      const response: any = await axios.get(url, { params: { branchId } });
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.UserMessage || 'Виникла помилка');
    }
  }

  public static async putSettings(body: any) {
    try {
      const url = `${ReservationsService.prefix}/Settings`;

      const response: any = await axios.put(url, body);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.UserMessage || 'Виникла помилка');
    }
  }
}
